module.exports = __webpack_public_path__ + "img/icon@2x (1).eb907523.png";